import { useObserver } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useQuery, useApolloClient } from '@apollo/react-hooks';

import { filteredOrders } from 'shared/graphql/order/queries.js';
import { PusherConfig } from 'shared/constants';

import useUser from 'hooks/use-user';
import usePusher from 'hooks/use-pusher';

export default function useOrderForConsumerView() {
  const user = useUser();
  const pusher = usePusher();
  const apolloClient = useApolloClient();

  const userId = useObserver(() => user.id);
  const viewOrderId = useObserver(() => user.viewOrderId);

  const { data, refetch, networkStatus, loading } = useQuery(filteredOrders, {
    variables: { ordersFilter: { orderId: viewOrderId, userId } },
    fetchPolicy: `cache-and-network`,
    pollInterval: 1000 * 30,
    client: apolloClient,
    skip: !userId,
  });

  const [order] = data?.filteredOrders?.orders || [];
  const orderId = order?.id;

  useEffect(() => {
    if (orderId) {
      const pusherChannel = pusher.subscribe(PusherConfig.Order.CHANNEL(orderId));
      pusherChannel.bind(PusherConfig.Order.Events.ORDER_UPDATED, refetch);

      return () => {
        pusher.unsubscribe(PusherConfig.Order.CHANNEL(orderId));
        pusherChannel.unbind(PusherConfig.Order.Events.ORDER_UPDATED, refetch);
      };
    }
  }, [pusher, refetch, orderId]);

  return { order, loading: loading && ![4, 6].includes(networkStatus) };
}
